import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/cn";
/**
 * A loading placeholder on the brand's track colour.
 *
 * It carries `aria-hidden` and `role="presentation"`: a skeleton is a picture
 * of content that does not exist yet, and announcing it is worse than silence.
 * The region it sits in should carry `aria-busy="true"` instead.
 *
 * The pulse is a `transition`-free animation, so the reduced-motion block in
 * base.css collapses it rather than leaving it running.
 */
export function Skeleton({ className, ...props }) {
    return (_jsx("div", { "data-slot": "skeleton", "aria-hidden": "true", role: "presentation", className: cn("lg:animate-pulse lg:rounded-md lg:bg-brand-surface3", className), ...props }));
}
//# sourceMappingURL=skeleton.js.map